import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Divider,
  Tooltip,
} from "@mui/material";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import GradeIcon from "@mui/icons-material/Grade";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import VerifiedIcon from "@mui/icons-material/Verified";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { palette, theme as colorTheme} from "../../../../Convoze.theme";


const SectionCard = ({ title, items, icon, color, tooltip }) => (
  <Box>
    <Box
      sx={{
        position: "absolute",
        height: "6px",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: color,
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
      }}
    />
    <Stack direction="row" spacing={1} alignItems="center" mb={2}>
      <Box sx={{ color }}>{icon}</Box>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {title}
        <Tooltip
          title={tooltip}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <InfoIcon
            sx={{
              fontSize: 18,
              color: "grey",
            }}
          />
        </Tooltip>
      </Typography>
    </Stack>
    <List dense>
      {items.map((item, index) => (
        <ListItem key={index} disableGutters>
          <ListItemIcon sx={{ minWidth: 28 }}>
            <FiberManualRecordIcon fontSize="8" sx={{ color: "#8B8B8B" }} />
          </ListItemIcon>
          <ListItemText
            primary={item}
            primaryTypographyProps={{ variant: "body2" }}
          />
        </ListItem>
      ))}
    </List>
  </Box>
);


const ProcessAndCoachable = ({ agentAnalytics }) => {
  const escalationData = agentAnalytics?.AnalyzeEscalation;
  console.log(escalationData , "escalationData------");
  
  const callAdherenceData = agentAnalytics?.CallAdherence;
  const rows = [
    {
      checkpoint: "Greeting Script Followed",
      ...agentAnalytics?.EvaluateCallAdherence,
    },
    {
      checkpoint: "Customer Verification Completed",
      ...agentAnalytics?.EvaluateCallAdherence?.CustomerVerificationCompleted,
    },
    {
      checkpoint: "Escalation Handled",
      ...agentAnalytics?.EvaluateCallAdherence?.EscalationHandled,
    },
    {
      checkpoint: "Refund Policy Explained",
      ...agentAnalytics?.EvaluateCallAdherence?.RefundPolicyExplained,
    },
    {
      checkpoint: "Resolution Summary Provided",
      ...agentAnalytics?.EvaluateCallAdherence?.ResolutionSummaryProvided,
    },
  ];
  const [expanded1Index, setExpanded1Index] = useState(0);
  const [expandedIndexScore, setExpandedIndexScore] = useState(0);
  const [expanded1IndexExpla, setExpanded1IndexExpla] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(true);
  const [expandedAccordion, setExpandedAccordion] = useState("quote");

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };
  const handleChange = () => {
    setExpandedIndex((prev) => !prev);
  };
  const handleChangeScore = () => {
    setExpandedIndexScore((prev) => !prev);
  };
  const handleChangeExpla = () => {
    setExpanded1IndexExpla((prev) => !prev);
  };

  const handleChange1 = (index) => (event, isExpanded) => {
    setExpanded1Index(isExpanded ? index : null);
  };

  return (
    <Box mt={3}>
      <Grid container spacing={3} width={"100%"}>
        {/* Process & Policy Adherence */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "none", flexDirection: "column" }}
        >
          <Paper
            elevation={1}
            sx={{
              flex: 1,
              borderRadius: 2,
            }}
          >
            <Box p={2}>
              <Typography
                variant="body1"
                mb={2}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                📚 Process & Policy Adherence
                <Tooltip
                  title="Gives adhrance details assoicated with the process and policy."
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InfoIcon
                    sx={{
                      fontSize: 18,
                      color: "grey",
                    }}
                  />
                </Tooltip>
              </Typography>

              <Box
                sx={{ display: { xs: "none", md: "block" }, height: "100%" }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>QA CHECKPOINT</TableCell>
                      <TableCell>AI RESULT</TableCell>
                      {/* <TableCell>QA OVERRIDE</TableCell>
                      <TableCell>FINAL STATUS</TableCell> */}
                      <TableCell>NOTES</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {agentAnalytics?.EvaluateCallAdherence?.length > 0
                      ? agentAnalytics?.EvaluateCallAdherence?.map(
                          (row, idx) => {
                            return (
                              <TableRow key={idx} hover>
                                <TableCell>{row?.CheckPoint}</TableCell>
                                <TableCell>
                                  {row?.AiResult == "pass" ? (
                                    <Box
                                      sx={{
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        backgroundColor: "success.light",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: 900,
                                      }}
                                    >
                                      <CheckIcon
                                        sx={{
                                          color: "white",
                                          fontWeight: 900,
                                          fontSize: 20,
                                        }}
                                      />
                                    </Box>
                                  ) : (
                                    <Box
                                      sx={{
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        // backgroundColor: "#EA5455", // red background
                                        backgroundColor:colorTheme('palette', 'negative').value,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{ color: "white", fontSize: 20 }}
                                      />
                                    </Box>
                                  )}
                                </TableCell>
                                {/* <TableCell>
                                  {row?.QaOverride? "Yes" : "No"}
                                </TableCell> */}
                                {/* <TableCell> */}
                                {/* <Chip
                                    label={
                                      row?.FinalStatus == "pass"
                                        ? "Pass"
                                        : "Fail"
                                    }
                                    size="small"
                                    sx={{
                                      backgroundColor:
                                        row?.FinalStatus == "pass"
                                          ? "success.light"
                                          : "error.light",
                                      color: "white",
                                    }}
                                  /> */}
                                {/* {row?.FinalStatus == "pass" ? (
                                    <Box
                                      sx={{
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        backgroundColor: "success.light",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: 900,
                                      }}
                                    >
                                      <CheckIcon
                                        sx={{
                                          color: "white",
                                          fontWeight: 900,
                                          fontSize: 20,
                                        }}
                                      />
                                    </Box>
                                  ) : (
                                    <Box
                                      sx={{
                                        width: 25,
                                        height: 25,
                                        borderRadius: "50%",
                                        backgroundColor: "#EA5455", // red background
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{ color: "white", fontSize: 20 }}
                                      />
                                    </Box>
                                  )}
                                </TableCell> */}
                                <TableCell>
                                  <Typography fontSize={13}>
                                    {row?.Notes ?? "-"}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )
                      : "No Data Available"}
                  </TableBody>
                </Table>
              </Box>

              {/* Mobile view: cards instead of table */}
              <Box sx={{ display: { xs: "block", md: "none" } }}>
                {rows?.map((row, idx) => (
                  <Paper
                    key={idx}
                    variant="outlined"
                    sx={{
                      p: 2,
                      mb: 2,
                      borderRadius: 2,
                      backgroundColor: "#f9fafb",
                    }}
                  >
                    <Typography variant="subtitle2" gutterBottom>
                      {row.checkpoint}
                    </Typography>
                    <Typography variant="body2">
                      <strong>AI RESULT:</strong> {row?.AiResult ?? "-"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>QA OVERRIDE:</strong> {row?.QaOverride ?? "-"}
                    </Typography>
                    <Typography variant="body2" sx={{ my: 1 }}>
                      <strong>FINAL STATUS:</strong>{" "}
                      <Chip
                        label={row?.FinalStatus ? "Pass" : "Fail"}
                        size="small"
                        sx={{
                          backgroundColor: row?.FinalStatus
                            ? "success.light"
                            : "error.light",
                          color: row?.FinalStatus ? "success.dark" : "white",
                        }}
                      />
                    </Typography>
                    <Typography variant="body2">
                      <strong>NOTES:</strong> {row?.Notes ?? "-"}
                    </Typography>
                  </Paper>
                ))}
              </Box>
            </Box>
          </Paper>
        </Grid>
        {/* <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={1}
            sx={{
              borderRadius: 2,
              flex: 1,
            }}
          >
            <Box p={2}>
              <Typography
                variant="body1"
                mb={1}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                💡 Coachable Moments & Tagging
                <Tooltip
                  title="Highlights the areas where the agent needs coaching along with qouting the sentence of the conversation."
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InfoIcon
                    sx={{
                      fontSize: 18,
                      color: "grey",
                    }}
                  />
                </Tooltip>
              </Typography>
              {agentAnalytics?.CoachableMomentsAndTagging?.map((item, i) => (
                <Box
                  key={i}
                  p={2}
                  mb={2}
                  borderRadius={2}
                  sx={{ backgroundColor: "#eff6ff", mt: 4 }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2">{item?.Phrase}</Typography>
                    <Typography fontStyle="italic">
                      {item?.Timestamp}
                    </Typography>
                  </Box>
                  <Typography variant="body2" mt={1}>
                    {item?.ReviewerComment}
                  </Typography>
                  <Box
                    mt={1}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography fontSize={13} mt={1}>
                      {item?.Tags}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid> */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={1}
            sx={{
              flex: 1,
              borderRadius: 2,
              p: 2,
            }}
          >
            <Typography
              variant="body1"
              mb={2}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <CheckCircleIcon
                sx={{
                  // color: "#FFA500",
                  color:colorTheme('palette', 'neutral').value,
                  fontSize: 22,
                }}
              />
              Call Adherence
              <Tooltip
                title="Gives the adherance scores of the agent with the script and mainly highlights areas of improvement"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Typography>
            <Box sx={{ height: 440, overflowY: "auto", pr: 1 }}>
              {callAdherenceData?.map((item, index) => {
                const keyss = item ? Object.keys(item) : "NA";
                return (
                  <>
                    <Accordion
                      key={index}
                      sx={{ mb: 2, borderRadius: 2 }}
                      expanded={expanded1Index === index}
                      onChange={handleChange1(index)}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: "#8B8B8B",
                            fontWeight: "bold",
                          }}
                        >
                          {keyss[0]?.replace(/([a-z])([A-Z])/g, "$1 $2") ||
                            "NA"}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Stack spacing={2}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <VerifiedIcon
                              fontSize="small"
                              sx={{ color: "green" }}
                            />

                            <Typography variant="body2">
                              <strong>Adhered:</strong>{" "}
                              {item?.[keyss]?.adhered || "NA"}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box display="flex" alignItems="center" gap={1}>
                            <GradeIcon fontSize="small" color="primary" />
                            <Typography variant="body2">
                              <strong>Score:</strong>{" "}
                              {item?.[keyss]?.score
                                ? `${item?.[keyss]?.score}/5`
                                : "NA"}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box display="flex" alignItems="center" gap={1}>
                            <FormatQuoteIcon
                              fontSize="small"
                              color="secondary"
                            />
                            <Typography variant="body2">
                              <strong>Quote:</strong>{" "}
                              {item?.[keyss]?.quote || "NA"}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box display="flex" alignItems="center" gap={1}>
                            <InfoIcon
                              fontSize="small"
                              sx={{ color: colorTheme('palette', 'primary').value }}
                            />
                            <Typography variant="body2">
                              <strong>Explanation:</strong>{" "}
                              {item?.[keyss]?.explanation || "NA"}
                            </Typography>
                          </Box>
                        </Stack>
                      </AccordionDetails>
                    </Accordion>
                  </>
                );
              })}
            </Box>
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={1}
            sx={{
              flex: 1,
              borderRadius: 2,
              p: 2,
            }}
          >
            <Typography
              variant="body1"
              mb={2}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  backgroundColor: colorTheme('palette', 'negative').value
                }}
              >
                {/* <ReportProblemIcon
                  sx={{ color: "#FFF", fontSize: 16 }}
                /> */}
                <ErrorOutlineIcon sx={{ color: "#FFF", fontSize: 18 }} />
              </Box>
              Escalations
              <Tooltip
                title=" Gives the escalation areas by identifying the trigger words and
            quoting the sentences."
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Typography>

            <Box sx={{ height: 440, overflowY: "auto", pr: 1 }}>
              <Stack direction={"column"}>
                <Accordion
                  expanded={expandedAccordion === "quote"}
                  onChange={handleAccordionChange("quote")}
                  sx={{ flex: 1, borderRadius: 2, margin: 0, mb: 2 }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box display="flex" gap={1}>
                      <FormatQuoteIcon fontSize="small" color="secondary" />
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        Quote
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={2}>
                      {escalationData?.quote || escalationData?.Quote ? (
                        Object.entries(
                          escalationData?.quote || escalationData?.Quote
                        ).map(([key, value]) => {
                          return (
                            <>
                              <Box display="flex" alignItems="center" gap={1}>
                                <Typography variant="body2" gap={5}>
                                  <strong>
                                    {key?.replace(/([a-z])([A-Z])/g, "$1 $2") ||
                                      "NA"}
                                    :
                                  </strong>{" "}
                                  {value || "NA"}
                                </Typography>
                              </Box>
                              <Divider />
                            </>
                          );
                        })
                      ) : (
                        <Typography variant="body2" gap={5}>
                          NA
                        </Typography>
                      )}
                    </Stack>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expandedAccordion === "score"}
                  onChange={handleAccordionChange("score")}
                  sx={{ flex: 1, borderRadius: 2, margin: 0, mb: 2 }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box display="flex" gap={1}>
                      <GradeIcon fontSize="small" color="primary" />
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        Score
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={2}>
                      <Box display="flex" alignItems="center" gap={1}>
                        {/* <VerifiedIcon
                                fontSize="small"
                                sx={{ color: "green" }}
                              /> */}

                        <Typography variant="body2" gap={2}>
                          {escalationData?.Score || "NA"}
                        </Typography>
                      </Box>
                      <Divider />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  sx={{ flex: 1, borderRadius: 2, margin: 0 }}
                  expanded={expandedAccordion === "explanation"}
                  onChange={handleAccordionChange("explanation")}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box display="flex" gap={1}>
                      <InfoIcon fontSize="small" sx={{ color: "green" }} />
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        Explanation
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={2}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2" gap={2}>
                          {escalationData?.Explanation || "NA"}
                        </Typography>
                      </Box>
                      <Divider />
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              </Stack>
            </Box>
          </Paper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={4}
            sx={{
              flex: 1,
              p: 3,
              borderRadius: 3,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <SectionCard
              tooltip="Gives the feedback assoicated with the agents process knowledge"
              title="Additional Suggestion"
              items={agentAnalytics?.AdditionalSuggestions || []}
              icon={<TipsAndUpdatesIcon />}
              // color="#1976d2"
              color={colorTheme('palette', 'primary').value}
            />
          </Paper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={4}
            sx={{
              flex: 1,
              p: 3,
              borderRadius: 3,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Grid item xs={12} md={12}>
              <SectionCard
                tooltip="Gives the areas of improvement and opportunities missed on the call."
                title="Missed out Opportunities"
                items={agentAnalytics?.MissedOpportunities || []}
                icon={<HighlightOffIcon />}
                // color="#d32f2f"
                color={colorTheme('palette', 'negative').value}
              />
            </Grid>
          </Paper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Paper
            elevation={4}
            sx={{
              flex: 1,
              p: 3,
              borderRadius: 3,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <SectionCard
              tooltip="Gives feedback on agent's skills and behaviour on the call."
              title="Recommendation"
              items={agentAnalytics?.AgentRecommendation || []}
              icon={<ThumbUpAltIcon />}
              // color="#2e7d32"
              color={colorTheme('palette', 'positive').value}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProcessAndCoachable;
